import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const LS_KEY = "cherish_cart_v1";

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try { return JSON.parse(localStorage.getItem(LS_KEY) || "[]"); } catch { return []; }
    });

    useEffect(() => {
        localStorage.setItem(LS_KEY, JSON.stringify(items));
    }, [items]);

    const add = (item) => {
        setItems((prev) => {
            const optsKey = JSON.stringify(item.selected_options || {});
            const key = `${item.product_id}-${item.size_label}-${optsKey}`;
            const existing = prev.find((p) => `${p.product_id}-${p.size_label}-${JSON.stringify(p.selected_options || {})}` === key);
            if (existing) {
                return prev.map((p) =>
                    p === existing ? { ...p, quantity: (p.quantity || 1) + (item.quantity || 1) } : p
                );
            }
            return [...prev, { quantity: 1, ...item }];
        });
    };

    const update = (index, patch) => {
        setItems((prev) => prev.map((p, i) => (i === index ? { ...p, ...patch } : p)));
    };

    const remove = (index) => setItems((prev) => prev.filter((_, i) => i !== index));
    const clear = () => setItems([]);

    const subtotal = items.reduce((sum, i) => sum + (i.unit_price_inr || 0) * (i.quantity || 1), 0);
    const count = items.reduce((sum, i) => sum + (i.quantity || 1), 0);

    return (
        <CartContext.Provider value={{ items, add, update, remove, clear, subtotal, count }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
